import { LOGIN, LOGOUT } from "./types";
import history from "../history";
import backend from "../apis/backend";
import errorHandler from "../helpers/errorHandler";

export const tryLogin = (formValues, onFieldError) => async (dispatch) => {
    try {
        const { data } = await backend.post("/api/auth/login", formValues, {
            headers: { 
                "Content-Type": "application/json"
            }
        });

        dispatch({ type: LOGIN, payload: data });
        history.push("/");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const tryLogout = () => async (dispatch) => {
    try {
        await backend.post("/api/auth/logout");

        dispatch({ type: LOGOUT });
        history.push("/login");
    }
    catch (error) { errorHandler(error, null); }
};

export const login = (token, userID) => ({
    type: LOGIN,
    payload: {
        token: token,
        userID: userID
    }
});